import {NgModule} from '@angular/core';
import {FixedPipe} from './fixed/fixed';
import {AbsPipe} from './abs/abs';
import {FloorPipe} from './floor/floor';
import {SignPipe} from './sign/sign';
import {OrderByPipe} from './order-by/order-by';
import {PositionDiffClassPipe} from './position-diff-class/position-diff-class';
import {PositionChangeValuePipe} from './position-change-value/position-change-value';
import {FrenchDecimalPipe} from './french-decimal/french-decimal';
import {EllipsisPipe} from './ellipsis/ellipsis';
import {RoundPipe} from './round/round';
import {DasherPipe} from './dasher/dasher';

@NgModule({
  declarations: [FixedPipe,
    AbsPipe,
    FloorPipe,
    SignPipe,
    OrderByPipe,
    PositionDiffClassPipe,
    PositionChangeValuePipe,
    FrenchDecimalPipe,
    EllipsisPipe,
    RoundPipe,
    DasherPipe],
  imports: [],
  exports: [FixedPipe,
    AbsPipe,
    FloorPipe,
    SignPipe,
    OrderByPipe,
    PositionDiffClassPipe,
    PositionChangeValuePipe,
    FrenchDecimalPipe,
    EllipsisPipe,
    RoundPipe,
    DasherPipe]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// ./src/shared/pipes/pipes.module.ts